import { Route, Routes } from "react-router-dom";
import "./App.css";
import Navbar from "./Components/Navbar/Navbar";
import Home from "./Components/Home";
import About from "./Components/About/About";
import Gallery from "./Components/Gallery";
import Wedding from "./Components/Wedding/Wedding";
import Rooms from "./Components/Rooms";
import BookNow from "./Components/BookNow";
// import Rooms1 from "./Components/Rooms/Rooms2/Rooms1";
import Rooms2 from "./Components/Rooms/Rooms2/Rooms2";
import Footer from "./Components/About/Footer";
function App() {
  return (
    <div className="App">
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/wedding" element={<Wedding />} />
        <Route path="/rooms" element={<Rooms />} />
        <Route path="/boook_now" element={<BookNow />} />
        <Route path="/DeluxRoom" element={<Rooms2 />} />
        <Route path="/SuiteRoom" element={<Rooms2 />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
